import GraphService from "@/service/GraphService";


const initialState = {
    graphs: [],
}

export default {
    namespaced: true,
    state: {...initialState},
    actions: {
        async fetchGraphs({commit}) {
            try {
                const resp = await GraphService.get()
                if (resp.status === 200) {
                    commit('setGraphs', resp.data)
                }
            } catch (e) {
                console.log(e)
            }
        }
    },
    mutations: {
        setGraphs(state, data) {
            state.graphs = data
        }
    },
    getters: {}
}